import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { HiringScreenComponent } from './HiringScreen.types'
import { useHiringScreen } from './useHiringScreen'

const HiringScreenDesktop = lazy(() => import('./HiringScreen.desktop'))

const HiringScreenMobile = lazy(() => import('./HiringScreen.mobile'))

export const HiringScreen: HiringScreenComponent = ({ navigation, route }) => {
  const props = useHiringScreen({ navigation, route })

  const Screen = props.isMobile ? HiringScreenMobile : HiringScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
